import { EC_TYPE_CED, EC_TYPE_EXT, EC_TYPE_RUC } from '../constants';
import { toast } from 'react-toastify';

export const setFinalDocId = (idTypeSelect, type, docId) => {
    let finalDocId = docId;
    let finalType = type;

    switch (true) {
        case idTypeSelect === EC_TYPE_RUC && type === 'N':
            finalDocId = docId.replace('001', '');
            break;
        case idTypeSelect === EC_TYPE_RUC && type === 'J':
            finalDocId = '';
            break;
        case idTypeSelect === EC_TYPE_CED && type === 'N':
            break;
        case idTypeSelect === EC_TYPE_EXT && type === 'NF':
            finalType = 'I';
            break;
        default:
            toast.error('Documento de identidad no válido');
            return;
    }

    return { finalDocId, finalType };
};
